'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createStore;

var _reduxSaga = require('redux-saga');

var _reduxSaga2 = _interopRequireDefault(_reduxSaga);

var _reactRouterRedux = require('react-router-redux');

var _redux = require('redux');

var _reduxFormSaga = require('redux-form-saga');

var _reduxFormSaga2 = _interopRequireDefault(_reduxFormSaga);

var _Banners = require('features/Banners/Banners.middleware');

var _decorateStore = require('./decorateStore');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Creates the redux store.
 */

function createStore(historyInstance, data) {
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      onError = _ref.onError;

  var middleware = [];

  if (historyInstance) {
    middleware.push((0, _reactRouterRedux.routerMiddleware)(historyInstance));
  }

  middleware.push((0, _Banners.bannerMiddleware)());

  var sagaMiddleware = (0, _reduxSaga2.default)({
    onError: onError || function () {
      return null;
    }
  });
  middleware.push(sagaMiddleware);

  var finalCreateStore = void 0;
  if (__LOCAL_DEV__ && __CLIENT__ && __DEVTOOLS__) {
    var _require = require('redux-devtools'),
        persistState = _require.persistState;

    var DevTools = require('containers/DevTools/DevTools').DevTools;

    finalCreateStore = (0, _redux.compose)(_redux.applyMiddleware.apply(undefined, middleware), window.devToolsExtension ? window.devToolsExtension() : DevTools.instrument(), persistState(window.location.href.match(/[?&]debug_session=([^&]+)\b/)))(_redux.createStore);
  } else {
    finalCreateStore = _redux.applyMiddleware.apply(undefined, middleware)(_redux.createStore);
  }

  var reducer = require('./modules/reducer').default;

  var baseStore = finalCreateStore(reducer, data || {});
  var store = (0, _decorateStore.decorateStore)(baseStore, sagaMiddleware);

  var history = void 0;
  if (historyInstance) {
    history = (0, _reactRouterRedux.syncHistoryWithStore)(historyInstance, store);
  }

  if (__LOCAL_DEV__ && module.hot) {
    module.hot.accept('./modules/reducer', function () {
      store.replaceReducer(require('./modules/reducer').default);
    });
  }

  sagaMiddleware.run(_reduxFormSaga2.default);

  return { store: store, history: history };
}